import axios from "axios";
import { toast } from "react-toastify";
import { REPORT_LIST_SUCCESS, ACTIVE_MATCH_LIST_SUCCESS, REPORT_DOWNLOAD_SUCCESS, REPORT_GET_DOWNLOAD_FILES_SUCCESS, REPORT_GET_DOWNLOAD_FILES_ERROR, IS_LOADING } from "./Type";
import { apiHeader } from "./ApiHeader";
import "react-toastify/dist/ReactToastify.css";
import { baseUrlPostGres } from "../constant";
import HandleError from "../HandleError";
import { apiVersion } from "src/utils/apiVersion";
import { saveAs } from "file-saver";
toast.configure();

export const getMatchList = (page, size, data) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/report/get_match_list?page=${page}&size=${size}`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: ACTIVE_MATCH_LIST_SUCCESS,
        payload: response.data,
      });
    })
    .catch((errors) => {
      HandleError(errors?.response?.data);
      console.log("user list error", errors);
    });
};

export const getReportData = (page, size, data) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/report/get_report_data?page=${page}&size=${size}`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      console.log("response-->>", response.data);
      dispatch({
        type: REPORT_LIST_SUCCESS,
        payload: response.data,
      });
    })
    .catch((errors) => {
      console.log("errors-->>", errors);
      HandleError(errors?.response?.data);
      console.log("transaction list error", errors);
    });
};

export const getReportDownload = (data) => (dispatch) => {
  let strQuery = "";
  if (data && typeof data === "object") {
    const queryParts = Object.entries(data)
      .filter(([_, value]) => value !== undefined && value !== null && value !== "")
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);

    strQuery = queryParts.join("&");
  }
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/report/get_report_download?` + strQuery, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      console.log("response-->>", response.data);
      dispatch({
        type: REPORT_DOWNLOAD_SUCCESS,
        payload: response.data,
      });
      response.data.status !== true ? toast.error(response.data.message, { theme: "colored" }) : toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      console.log("errors-->>", errors);
      HandleError(errors?.response?.data);
      console.log("transaction list error", errors);
    });
};

export const getReportDownloadFiles = () => async (dispatch) => {
  dispatch({ type: IS_LOADING });

  try {
    const response = await axios.get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/report/get-downloads`, {
      headers: apiHeader(),
    });

    dispatch({
      type: REPORT_GET_DOWNLOAD_FILES_SUCCESS,
      payload: response?.data?.data || [],
    });
  } catch (error) {
    dispatch({
      type: REPORT_GET_DOWNLOAD_FILES_ERROR,
      payload: [],
    });
  }
};

export const downloadReportFile = (fileId, fileName) => async () => {
  try {
    const response = await axios.get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/report/download-file/${fileId}`, {
      responseType: "blob",
      headers: apiHeader(),
    });

    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    saveAs(blob, fileName || "transaction.xlsx");
  } catch (error) {
    console.error("Download error:", error);
  }
};
export const deleteAllFiles = () => async (dispatch) => {
  try {
    await axios.delete(`${baseUrlPostGres()}/admin/${apiVersion.v1}/report/files`, { headers: apiHeader() });

    dispatch({
      type: REPORT_GET_DOWNLOAD_FILES_SUCCESS,
      payload: [],
    });

    toast.success("All files deleted successfully!");
  } catch (error) {
    console.error("Delete error:", error);
    toast.error("Failed to delete files!");
  }
};
